import {Component, OnInit} from '@angular/core';
// tslint:disable-next-line:import-blacklist
import {Subject} from 'rxjs';
import {ToasterService} from 'angular2-toaster';
import {GeneralConstants} from '../../shared/general.constants';
import * as _ from 'lodash';
import {BulkInfohashV2TitlesService} from './bulk-infohash-v2-titles.service';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';
import {BulkInfohashV2Service} from '../model/bulk-infohash-v2.service';
import {query} from '@angular/animations';

const DEBOUNCE_TIME = 500;
const ES_RESULTS_SIZE = 20;
const ES_LARGER_SEARCH_AMOUNT = 100;

const PAGE_SIZE = 100;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'bulk-infohash-search-titles',
    templateUrl: 'bulk-infohash-v2-titles.component.html',
    styleUrls: ['bulk-infohash-v2-titles.component.scss']
})
export class BulkInfohashV2TitlesComponent implements OnInit {
    // Navigation
    private navIndex = 0;


    private APPROVE_QUERY_OBJECT = {
        'infohash': '',
        'properties': [
            {
                'property': 'human_verified',
                'property_value': true
            }
        ]
    };

    private REJECT_QUERY_OBJECT = {
        'infohash': '',
        'properties': [
            {
                'property': 'parrot_id',
                'property_value': '0'
            },

            {
                'property': 'human_verified',
                'property_value': true
            }
        ]
    };

    private UPDATE_INFOHASH_OBJECT = {
        'property': '',
        'value': ''
    };

    private REDIRECT_QUERY_OBJECT = {
        'infohash': '',
        'redirected_from': '',
        'redirected_to': '',
        'category': ''
    };

    private SEARCH_QUERY_OBJECT = {

        'start_date': '',
        'end_date': '',
        'human_verified': '',
        'system_verified': '',
        'smart_grouping': '',
        'order_by': '',
        'query_by': '',
        'order_direction': '',
        'size': '',
        'page': '',
        'category': '',
        'parrot_only': '',
        'catalog_states': '',
        'daily': ''
    };

    // Checkboxes
    private checkboxesDup = {
        humanVerifiedTrue: false,
        humanVerifiedFalse: true,
        systemVerifiedTrue: true,
        systemVerifiedFalse: true
    };
    private shouldDoSearch = false;

    // Checkboxes and values for original country/language/network filters
    private checkboxes = {
        byDate: true,
        systemVerifiedTrue: true,
        systemVerifiedFalse: true,
        humanVerifiedTrue: false,
        humanVerifiedFalse: true,
        smartGrouping: false,
        parrotIdOnly: true,
        demandOnly: true,
        queryByState: true,
        clientReadyOnly: false,
        byParrotid: false,
        byTitle: false,
        byInfohash: false,
        byOtherFilterCriteria: false,
        sortState: true,
        sortDirection: true
    };
    private isCollapsed = false;
    private countrySubject = new Subject<string>();
    private originalCountry = '';
    private languageSubject = new Subject<string>();
    private byParrotIdSearch = '';
    private networkSubject = new Subject<string>();
    private byTitleSearch = '';
    private byInfohashSearch = '';
    // private humanVerifiedState = ['false'];
    // private systemVerifiedState = ['true', 'false'];
    private sortValues = ['Tracking Date', 'Infohash', 'Hygiene Title', 'Parrot Id', 'Discovery Date', 'Cumulative Total Records'];
    private queryByValues = ['Tracking Date', 'Discovery Date'];
    private sortDirectionValues = ['Descending', 'Ascending'];
    private catalogStateSubject = new Subject<string>();
    private sortByState = 'tracked_on';
    private sortByValue = 'Tracking Date';
    private queryByValue = 'Tracking Date';
    private sortDirectionState = 'Descending';
    private queryByState = 'tracked_on';
    private sortDirectionValue = 'DESC';
    private contentType = 'tv';

    private page = 1;
    private maxPages;


    // Subject for search debounce and search value
    private subject = new Subject<string>();
    private searchValue = '';

    private searchLoading = false;

    private results = [];
    private dailyStatsResult = [];
    private allInfohashStatsResult = [];
    private dailyTVStatsResult = [];
    private allInfohashTVStatsResult = [];
    private dailyMovieStatsResult = [];
    private allInfohashMovieStatsResult = [];

    private selectedShow;

    private createTitleRequests = false;

    private totalResults = 0;
    private totalResultsImdb = 0;
    private from = 0;
    private largerSearch = false;
    private hasMore = false;
    private categoryType: number = 0;
    private statsCategoryType: number = 0;
    private allStatsCategoryType: number = 0;
    private infohashType: number = 2;
    private categoryTypeValue = 'tv';
    private infohashTypeValue = 'tv';

    private startDate = new Date();
    private endDate = new Date();
    private maxDate = new Date();
    private loadingInfohash = false;
    private searchQuery = '';
    private popup = false;
    private allInfohashpopup = false;
    private loadingDailyStats = false;
    private loadingAllInfohashStats = false;


    constructor(private infohashService: BulkInfohashV2Service, private catalogService: CatalogService,
                private toasterService: ToasterService,
                private generalConstants: GeneralConstants) {
        this.startDate = new Date('2015-04-01');
    }

    ngOnInit() {
        this.countrySubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(country => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.languageSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(language => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.networkSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(network => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.catalogStateSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(catalogState => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.subject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged((prev, curr) => prev === curr && !this.shouldDoSearch)
            .subscribe(searchValue => {
                // Search value has changed, reset results, total results and from
                this.results = [];
                this.totalResultsImdb = 0;
                this.totalResults = 0;
                this.from = 0;
            });
    }


    handleLoadMore() {

        this.page = this.page + 1;
        this.handleSearch(true);

    }

    handlePreviousPage() {

        this.page = this.page - 1;
        this.handleSearch(true);

    }

    handleNavSelect(index) {
        this.navIndex = index;
    }

    handleCheckBoxes(checkboxName) {
        this.checkboxes[checkboxName] = !this.checkboxes[checkboxName];
    }

    handleOriginalFiltersCheckboxes(checkboxName) {
        this.checkboxes[checkboxName] = !this.checkboxes[checkboxName];
        if (this.shouldSearch()) {
            switch (checkboxName) {
                case 'byParrotid':
                    if (this.byParrotIdSearch && this.byParrotIdSearch !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
                case 'byTitle':
                    if (this.byTitleSearch && this.byTitleSearch !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
                case 'byInfohash':
                    if (this.byInfohashSearch && this.byInfohashSearch !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
            }
        } else {
            this.results = [];
        }
    }

    handleUpdateTorrents(result) {
        this.loadingInfohash = true;

        const updateObject = this.createUpdateObject(result);

        console.log(updateObject);

        this.infohashService.updateInfohashesh(
            updateObject,
        ).then((res) => {

            if (res) {

                this.toasterService.pop('info', 'Successfully Updated the Infohashes');

                this.handleSearch(false);

            } else {
                console.log(res);
                this.toasterService.pop('error', 'Failed to get infohashes');
                this.loadingInfohash = false;
            }
        }).catch((err) => {
            console.error('Failed to update' + err.toString());
            this.toasterService.pop('error', 'Failed to update');
            this.loadingInfohash = false;
        });


    }

    handleSmartGroupedResults(result) {

        const startDate = this.startDate.toISOString().slice(0, 10);
        const endDate = this.endDate.toISOString().slice(0, 10);

        const humanVerfiedState = [];

        if (this.checkboxes['humanVerifiedTrue']) {
            humanVerfiedState.push(this.checkboxes['humanVerifiedTrue']);
        }

        if (this.checkboxes['humanVerifiedFalse']) {
            humanVerfiedState.push(!this.checkboxes['humanVerifiedFalse']);
        }

        const systemVerfiedState = [];

        if (this.checkboxes['systemVerifiedTrue']) {
            systemVerfiedState.push(this.checkboxes['systemVerifiedTrue']);
        }

        if (this.checkboxes['systemVerifiedFalse']) {
            systemVerfiedState.push(!this.checkboxes['systemVerifiedFalse']);
        }

        if (!this.selectedShow || (this.selectedShow && this.selectedShow.parrot_id !== result.parrotId)) {
            this.selectedShow = {
                parrot_id: result.parrot_id,
                start_date: startDate,
                end_date: endDate,
                human_verified: humanVerfiedState,
                system_verified: systemVerfiedState,
                category: this.categoryTypeValue,
                parrot_only: this.checkboxes['parrotIdOnly'],
                demand_only: this.checkboxes['demandOnly'],
            };
        } else if (this.selectedShow && this.selectedShow.parrot_id === result.parrotId) {
            // Trigger a change for the property
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: undefined,
                    catalog_state: 'client_ready',
                    title: undefined,
                    content_type: undefined,
                    display_name: undefined
                };
            });
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: result.parrot_id,
                    start_date: startDate,
                    end_date: endDate,
                    human_verified: humanVerfiedState,
                    system_verified: systemVerfiedState,
                    category: this.categoryTypeValue,
                    parrot_only: this.checkboxes['parrotIdOnly'],
                    demand_only: this.checkboxes['demandOnly'],
                };
            });
        }
    }


    createUpdateObject(results) {

        const updateObject = [];

        results.map((item) => {

            if (item.action === 'approved') {

                const approvedUpdateObject = _.cloneDeep(this.APPROVE_QUERY_OBJECT);

                approvedUpdateObject.infohash = item.infohash;

                updateObject.push(approvedUpdateObject);

            }

            if (item.action === 'rejected') {
                const rejectedUpdateObject = _.cloneDeep(this.REJECT_QUERY_OBJECT);

                rejectedUpdateObject.infohash = item.infohash;

                updateObject.push(rejectedUpdateObject);

            }

            if (item.action === 'catalog_gap') {
                const rejectedUpdateObject = _.cloneDeep(this.REJECT_QUERY_OBJECT);

                rejectedUpdateObject.infohash = item.infohash;

                updateObject.push(rejectedUpdateObject);

            }

            if ((item.action === 'redirect') || (item.action === 'updated')) {

                const propertiesArray = [];

                propertiesArray.push({
                    'property': 'parrot_id',
                    'property_value': item.parrot_id
                });

                propertiesArray.push({
                    'property': 'title',
                    'property_value': item.title
                });

                propertiesArray.push({
                    'property': 'category',
                    'property_value': item.category
                });

                propertiesArray.push({
                    'property': 'human_verified',
                    'property_value': true
                });

                const finalRedirectObject = {
                    'infohash': item.infohash,
                    'properties':
                    propertiesArray
                };

                updateObject.push(finalRedirectObject);
            }

        });

        console.log(JSON.stringify(updateObject));

        return JSON.stringify(updateObject);

    }

    private createRedirectUpdateObject(item) {
        const redirectObject = _.cloneDeep(this.REDIRECT_QUERY_OBJECT);

        redirectObject.infohash = item.infohash;
        redirectObject.redirected_from = item.redirected_from;
        redirectObject.redirected_to = item.parrot_id;
        redirectObject.category = item.category;

        return redirectObject;

    }

    handleClearTorrents(result) {
        this.handleSearch(false);
    }

    handleCreateTitle() {
        this.createTitleRequests = true;
        setTimeout(() => {
            this.createTitleRequests = false;
        }, 1000);
    }

    onKeyUp(searchValue) {
        this.searchValue = searchValue;
        if (this.shouldSearch()) {
            this.subject.next(searchValue);
        } else {
            this.results = [];
        }
    }

    onOriginalKeyUp(value, type) {
        switch (type) {
            case 'byParrotid':
                this.byParrotIdSearch = value;
                break;
            case 'byTitle':
                this.byTitleSearch = value;
                break;
            case 'byInfohash':
                this.byInfohashSearch = value;
                break;
            case 'byDate':
                break;
            case 'sortState':
                if (value) {
                    this.sortByValue = value;
                    if (value === 'Tracking Date') {
                        this.sortByState = 'tracked_on';
                    } else if (value === 'Infohash') {
                        this.sortByState = 'infohash';
                    } else if (value === 'Hygiene Title') {
                        this.sortByState = 'hygiene_title';
                    } else if (value === 'Parrot Id') {
                        this.sortByState = 'parrot_id';
                    } else if (value === 'Discovery Date') {
                        this.sortByState = 'discovery_time';
                    } else if (value === 'Cumulative Total Records') {
                        this.sortByState = 'cumulative_total_records';
                    }
                }
                break;
            case 'queryByState':
                if (value) {
                    this.queryByValue = value;
                    if (value === 'Tracking Date') {
                        this.queryByState = 'tracked_on';
                    } else if (value === 'Discovery Date') {
                        this.queryByState = 'discovery_time';
                    }
                }
                break;
            case 'sortDirection':
                if (value) {
                    this.sortDirectionState = value;
                    if (value === 'Ascending') {
                        this.sortDirectionValue = 'ASC';
                    } else if (value === 'Descending') {
                        this.sortDirectionValue = 'DESC';
                    }
                }
                break;
        }
    }

    shouldSearch() {
        return this.searchValue || (this.checkboxes.byDate ||
            this.checkboxes.byParrotid || this.checkboxes.byTitle || this.checkboxes.byInfohash);
    }

    onCategoryTypeChange(value: number) {
        this.categoryType = value;

        if (value === 1) {
            this.categoryTypeValue = 'movie';
        } else {
            this.categoryTypeValue = 'tv';

        }
    }

    onStatsCategoryTypeChange(value: number) {
        this.statsCategoryType = value;
    }

    onAllStatsCategoryTypeChange(value: number) {
        this.allStatsCategoryType = value;
    }

    onInfohashTypeChange(value: number) {
        this.infohashType = value;

        if (value === 0) {
            this.infohashTypeValue = 'active movie infohashes';
        } else if (value === 1) {
            this.infohashTypeValue = 'all infohashes';
            this.byParrotIdSearch = '';
            this.byInfohashSearch = '';
            this.byTitleSearch = '';
            this.checkboxes['byParrotid'] = false;
            this.checkboxes['byTitle'] = false;
            this.checkboxes['byInfohash'] = false;
        } else if (value === 2) {
            this.infohashTypeValue = 'daily discovered infohashes';
            this.byParrotIdSearch = '';
            this.byInfohashSearch = '';
            this.byTitleSearch = '';
            this.checkboxes['byParrotid'] = false;
            this.checkboxes['byTitle'] = false;
            this.checkboxes['byInfohash'] = false;
        } else {
            this.infohashTypeValue = 'search criteria';
        }
    }

    handleNextPage() {
        this.handleGoToPage(this.page + 1);
    }

    handleFirstPage() {
        this.handleGoToPage(1);
    }

    handleLastPage() {
        this.handleGoToPage(this.maxPages);
    }

    handleGoToPage(page) {
        this.page = page;
    }

    handleSearch(navigatePage) {

        if (!navigatePage) {
            this.page = 1;
        }

        this.isCollapsed = true;
        this.results = [];
        this.loadingInfohash = true;
        this.searchQuery = this.createSearchQuery();
        // tslint:disable-next-line:max-line-length

        if (this.checkboxes.byParrotid) {
            this.getSearchtermResults(this.byParrotIdSearch, this.categoryTypeValue);
        } else if (this.checkboxes.byTitle) {
            this.getSearchtermResults(this.byTitleSearch, this.categoryTypeValue);
        } else if (this.checkboxes.byInfohash) {
            this.getSearchtermResults(this.byInfohashSearch, this.categoryTypeValue);
        } else if (this.checkboxes['smartGrouping']) {
            this.getSmartGroupedResults();
        } else {
            this.getNonSmartGroupedResults();
        }

    }

    getNonSmartGroupedResults() {
        this.infohashService.getInfohashesBySearchQuery(
            this.searchQuery,
        ).then((res) => {

            this.results = this.results.concat(res.torrents.map(item => this.infohashService.infohashResultItem(item)));
            this.totalResults = res.page_info.maxpage;
            this.totalNumberOfTorrents = res.page_info.totalitems;
            if (this.totalResults > (this.page)) {
                this.hasMore = true;
            } else {
                this.hasMore = false;
            }
            this.loadingInfohash = false;
        }).catch((err) => {
            console.error('Failed to fetch infohashes in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to fetch infohashes');
            this.loadingInfohash = false;
            this.isCollapsed = false;

        });
    }


    getSearchtermResults(queryTerm, category) {
        this.infohashService.getSearchedTorrents(
            queryTerm, category
        ).then((res) => {

            this.results = this.results.concat(res.torrents.map(item => this.infohashService.infohashResultItem(item)));
            this.totalNumberOfTorrents = this.results.length;
            this.hasMore = false;

            this.loadingInfohash = false;
        }).catch((err) => {
            console.error('Failed to fetch infohashes in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to fetch infohashes');
            this.loadingInfohash = false;
            this.isCollapsed = false;

        });
    }

    getSmartGroupedResults() {
        this.infohashService.getInfohashesBySearchQuery(
            this.searchQuery,
        ).then((res) => {

            this.results = this.results.concat(res.torrent_groups.map(item => this.infohashService.infohashResultItem(item)));
            this.totalResults = res.page_info.maxpage;
            this.totalNumberOfTorrents = res.page_info.totalitems;
            if (this.totalResults > (this.page)) {
                this.hasMore = true;
            } else {
                this.hasMore = false;
            }
            this.loadingInfohash = false;
        }).catch((err) => {
            console.error('Failed to fetch infohashes in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to fetch infohashes');
            this.loadingInfohash = false;
            this.isCollapsed = false;

        });
    }

    createSearchQuery() {
        const requestQuery = _.cloneDeep(this.SEARCH_QUERY_OBJECT);

        const category = [];
        category.push(this.categoryTypeValue);
        const humanVerfiedState = [];

        if (this.checkboxes['humanVerifiedTrue']) {
            humanVerfiedState.push(this.checkboxes['humanVerifiedTrue']);
        }

        if (this.checkboxes['humanVerifiedFalse']) {
            humanVerfiedState.push(!this.checkboxes['humanVerifiedFalse']);
        }

        const systemVerfiedState = [];

        if (this.checkboxes['systemVerifiedTrue']) {
            systemVerfiedState.push(this.checkboxes['systemVerifiedTrue']);
        }

        if (this.checkboxes['systemVerifiedFalse']) {
            systemVerfiedState.push(!this.checkboxes['systemVerifiedFalse']);
        }

        const startDate = this.startDate.toISOString().slice(0, 10);
        const endDate = this.endDate.toISOString().slice(0, 10);

        requestQuery.page = this.page;
        requestQuery.size = PAGE_SIZE;

        if (this.checkboxes.byParrotid) {
            requestQuery.search_term = this.byParrotIdSearch;
            requestQuery.search_by = 'parrot_id';
        }
        if (this.checkboxes.byTitle) {
            requestQuery.search_term = this.byTitleSearch;
            requestQuery.search_by = 'titles';
        }
        if (this.checkboxes.byInfohash) {
            requestQuery.search_term = this.byInfohashSearch;
            requestQuery.search_by = 'infohash';
        }
        if (this.checkboxes.byDate) {
            requestQuery.start_date = startDate;
            requestQuery.end_date = endDate;
        }

        if (this.infohashType === 2) {
            requestQuery.daily = true;
        } else {
            requestQuery.daily = false;
        }

        if (this.checkboxes['demandOnly']) {
            requestQuery.catalog_states = ['client_ready', 'demand_generation', 'requested', 'harvested'];
        } else if (this.checkboxes['clientReadyOnly']) {
            requestQuery.catalog_states = ['client_ready'];
        } else {
            requestQuery.catalog_states = ['metadata_ready', 'client_ready', 'demand_generation', 'requested', 'harvested'];
        }


        requestQuery.human_verified = humanVerfiedState;
        requestQuery.system_verified = systemVerfiedState;
        requestQuery.smart_grouping = this.checkboxes['smartGrouping'];
        requestQuery.parrot_only = this.checkboxes['parrotIdOnly'];
        requestQuery.category = this.categoryTypeValue;
        requestQuery.order_by = this.sortByState;
        requestQuery.query_by = this.queryByState;
        requestQuery.order_direction = this.sortDirectionValue;

        return JSON.stringify(requestQuery);


    }

// tslint:disable-next-line:member-ordering
    public pieChartLabels: string[] = ['Approved', 'Rejected', 'Pending'];
    // tslint:disable-next-line:member-ordering
    public pieChartLabelsCB: string[] = ['Low', 'Medium', 'High'];
    // tslint:disable-next-line:member-ordering
    public pieChartData: number[] = [600708, 27947, 1227607];
    // tslint:disable-next-line:member-ordering
    public pieChartDataCB: number[] = [600708, 27947, 1227607];
    // tslint:disable-next-line:member-ordering
    public pieChartType: string = 'pie';

    // tslint:disable-next-line:member-ordering
    public totalNumberOfTorrents;

    // tslint:disable-next-line:member-ordering
    pieChartColor: any = [
        {
            backgroundColor: ['rgba(30, 169, 224, 0.8)',
                'rgba(255,165,0,0.9)',
                'rgba(139, 136, 136, 0.9)',

            ]
        }
    ];

    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }

    collapseSearchView(b: boolean) {
        this.isCollapsed = b;
    }

    getInfohashStats(popup: boolean, type: string) {

            if (type === 'daily') {
                this.popup = popup;
                if (!popup) {
                    return;
                }
                this.loadingDailyStats = true;
                this.dailyStatsResult = [];
                this.statsCategoryType = 0;
                this.dailyTVStatsResult = [];
                this.dailyMovieStatsResult = [];
                this.getDailyStatsResults();
            } else {
                this.allInfohashpopup = popup;
                if (!popup) {
                    return;
                }
                this.loadingAllInfohashStats = true;
                this.allInfohashStatsResult = [];
                this.allStatsCategoryType = 0;
                this.allInfohashTVStatsResult = [];
                this.allInfohashMovieStatsResult = [];
                this.getAllInfohashStatsResults();
            }

    }

    getDailyStatsResults() {
        this.infohashService.getDailyTorrentsStats()
            .then((res) => {
                this.dailyStatsResult = this.dailyStatsResult.concat(res.monthly_stats.map(item => this.infohashService.infohashStatsItem(item)));

                this.dailyTVStatsResult = this.dailyStatsResult.filter(obj => obj.category === 'tv').sort((a, b) => (a.discovery_time < b.discovery_time) ? 1 : -1);
                this.dailyMovieStatsResult = this.dailyStatsResult.filter(obj => obj.category === 'movie').sort((a, b) => (a.discovery_time < b.discovery_time) ? 1 : -1);

                this.loadingDailyStats = false;
            }).catch((err) => {
            console.error('Failed to fetch daily infohashes stats' + err.toString());
            this.toasterService.pop('error', 'Failed to fetch daily infohashes stats');
            this.loadingDailyStats = false;
            this.popup = false;

        });
    }


    getAllInfohashStatsResults() {
        this.infohashService.getAllInfohashTorrentsStats()
            .then((res) => {
                this.allInfohashStatsResult = this.allInfohashStatsResult.concat(res.historic_stats.map(item => this.infohashService.allInfohashStatsItem(item)));

                this.allInfohashTVStatsResult = this.allInfohashStatsResult.filter(obj => obj.category === 'tv').sort((a, b) => (a.discovery_time < b.discovery_time) ? 1 : -1);
                this.allInfohashMovieStatsResult = this.allInfohashStatsResult.filter(obj => obj.category === 'movie').sort((a, b) => (a.discovery_time < b.discovery_time) ? 1 : -1);

                this.loadingAllInfohashStats = false;
            }).catch((err) => {
            console.error('Failed to fetch all infohashes stats' + err.toString());
            this.toasterService.pop('error', 'Failed to fetch all infohashes stats');
            this.loadingAllInfohashStats = false;
            this.allInfohashpopup = false;

        });
    }

}



// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/bulk-infohash-v2-search/bulk-infohash-v2-titles.component.ts